import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { AlertaSimplesDialog } from '../alerta-simples';
import { AlertaInputDialog } from '../alerta-input';
import { AlertaConfirmDialog } from '../alerta-confirm';

@Component({
  selector: 'app-dashboard-paciente-novo',
  templateUrl: './dashboard-paciente-novo.component.html',
  styleUrls: ['./dashboard-paciente-novo.component.css']
})
export class DashboardPacienteNovoComponent implements OnInit {
  hideCL: boolean = false;
  nomeCidade: any = '';
  qBuscado: any = '';
  tipoListar: any = '';
  arrResults: any[] = [];
  arrResultsG: any[] = [];
  urlFoto: any = '';
  indexBusca: any = 0;
  qtdResultados: any = 0;
  fraseExib: any = '';
  onDemand: boolean = false;
  parametroB: any = '';
  email: any = '';
  nome: any = '';
  nascimento: string = '';
  celular: string = '';
  genero: any = '';
  altura: any = '';
  peso: any = '';
  dadosPaciente: any;
  jaCadastrado: boolean = false;
  etapaEmail: boolean = true;
  etapaDados: boolean = false;
  public maskNascimento = [ /[0-9]/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public maskTelefone = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/,/\d/,/\d/, '-', /\d/, /\d/, /\d/, /\d/];

  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService, public dialog: MatDialog) { 

  }

  ngOnInit() {
    this.hideCL = true;
    this.tmaService.eventoFS(true);
    //this.nomeCidade = this.route.snapshot.paramMap.get('cidade');
    //padrões: todos, ultimos, listar (pesquisa)
    
    //listar: nome, email ou telefone
    
    //this.arrResults.push({qq: 1});
    
    
  }
  ngOnDestroy(){
    console.log("destroy");
    this.tmaService.eventoFS(false);
  }

  funcaoInicial() :void{
    this.tipoListar =  this.route.snapshot.paramMap.get('tipo');
    this.qBuscado = this.route.snapshot.paramMap.get('parametrobusca');
    if(this.tipoListar == 'all'){
      this.obterResultados();
    }
    else{
      this.obterResultadosP();
    }
  }

  obterResultados() :void{
    //this.tipoListar =  this.route.snapshot.paramMap.get('tipo');
    
    this.hideCL = false;
    var gDados = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&tipopesquisa=' + this.tipoListar + '&parametro=' + this.qBuscado + '&meuindex=' + this.indexBusca;
    //var gDados = 'txtpesquisa=' + this.qBuscado + '&email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha;
    this.tmaService.getPacientes(gDados)
    .subscribe((qRes) =>{
      console.log(qRes);
      this.hideCL = true;
      if(qRes['res'] == 'done'){
        if(this.indexBusca != 0){
          console.log("somar");
          var testX = [];
          this.arrResults = this.arrResults.concat(qRes['objResultado']);
        }
        else{
          console.log("first time");
          this.arrResults = qRes['objResultado'];
          //this.arrResults = Object.assign([], qRes['objResultado']);

        }
        
        console.log(this.arrResults);
        this.qtdResultados = qRes['qtdTotal'];

        this.urlFoto =  this.tmaService.urlRepositorioS3 + "/users-profile-picture/";

        if(this.arrResults.length < this.qtdResultados){
          this.onDemand = true;
          this.indexBusca = this.arrResults.length;
          this.fraseExib = 'Exibindo <b>' + this.arrResults.length + '</b> de <b>' + this.qtdResultados + '</b> resultados encontrados';
        }
        else{
          this.fraseExib = 'Encontramos <b>' + this.arrResults.length + '</b> pacientes cadastrados';
          this.onDemand = false;
        }
      }
    })
  }

  obterResultadosP() :void{
    this.hideCL = false;
    //this.tipoListar = 'listar';
    var gDados = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&tipopesquisa=listar&parametro=' + this.qBuscado + '&meuindex=' + this.indexBusca;
    //var gDados = 'txtpesquisa=' + this.qBuscado + '&email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha;
    this.tmaService.getPacientes(gDados)
    .subscribe((qRes) =>{
      console.log(qRes);
      this.hideCL = true;
      if(qRes['res'] == 'done'){
        if(this.indexBusca != 0){
          console.log("somar");
          var testX = [];
          this.arrResults = this.arrResults.concat(qRes['objResultado']);
        }
        else{
          console.log("first time");
          this.arrResults = qRes['objResultado'];
          //this.arrResults = Object.assign([], qRes['objResultado']);

        }
        
        console.log(this.arrResults);
        this.qtdResultados = qRes['qtdTotal'];

        this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-profile-picture/";

        if(this.arrResults.length < this.qtdResultados){
          this.onDemand = true;
          this.indexBusca = this.arrResults.length;
          this.fraseExib = 'Exibindo <b class="res_b">' + this.arrResults.length + '</b> de <b class="res_b">' + this.qtdResultados + '</b> resultados encontrados para <b>' + this.qBuscado + '</b>';
        }
        else{
          this.fraseExib = 'Encontramos <b class="res_b">' + this.arrResults.length + '</b> resultados para <b class="res_b">' + this.qBuscado + '</b>';
          this.onDemand = false;
        }
      }
    })
  }

  pesquisarPaciente()  :void{
    const addNT = this.dialog.open(AlertaInputDialog, {
      width: '250px',
      disableClose: true,
      data: {iconAlerta: "", textoInput: 'Nome', tipoInput: 'text', nomeInput: 'nome',  tituloAlerta: 'Pesquisar', textoAlerta: 'Digite o nome do paciente', textoCancel: 'Cancelar', textoConfirm: "OK"}
    });
    addNT.afterClosed().subscribe(result =>{
      console.log(result);
      if(result !== false && result !== undefined){
        //server side
        if(result.length <= 3){
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose:true,
            data: {textoAlerta: "Digite pelo menos 4 caracteres para realizar a busca", iconAlerta: 'warning'}
          });
        }
        else{
          this.indexBusca = 0;
          this.router.navigate(['/dashboard/pacientes/listar/' + result]);
        }
        //alterar route
        // this.qBuscado = result;
        // this.indexBusca = 0;
        // this.obterResultadosP();

      }
    })
  }

  checkEmail() :void{

    if (this.email == '') {
      const emailInsuf = this.dialog.open(AlertaSimplesDialog, {
          data: {iconAlerta: 'warning', textoAlerta: "Por favor insira seu e-mail"}
      });
      // emailInsuf.afterClosed().subscribe(qq1 =>{
      //     this.emailInput.nativeElement.focus();
      // });
      return ;
    }
    else {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.email);
        console.log("R " + re);
        if (re !== true) {
            const emailInv = this.dialog.open(AlertaSimplesDialog, {
                data: {iconAlerta: 'warning', textoAlerta: "E-mail invalido, por favor verifique se digitou corretamente"}
            });
            return ;
        }
    }


    this.hideCL = false;
    //this.tipoListar = 'listar';
    var gDados = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&tipopesquisa=email&parametro=' + this.email + '&meuindex=' + this.indexBusca;
    //var gDados = 'txtpesquisa=' + this.qBuscado + '&email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha;
    this.tmaService.getUsuariosP(gDados)
    .subscribe((qRes) =>{
      console.log(qRes);
      this.hideCL = true;
      if(qRes['res'] == 'done'){
        if(qRes['objResultado'] == null){
          this.jaCadastrado = false;
          //sem cadastro
          if(qRes['already'] == false){
            //liberado next step
            this.etapaEmail = false;
            this.etapaDados = true;
          }
          else{
            //email já em uso
            const avisoErro =  this.dialog.open(AlertaConfirmDialog, {
              // width: '250px',
              disableClose: true,
              data: { iconAlerta: 'warning', tituloAlerta: "Aviso",  textoAlerta: "E-mail não permitido para cadastro. Insira um novo e-mail e tente novamente", textoConfirm: "OK"}
            });
          }
        }
        else{
          this.jaCadastrado = true;
          this.etapaEmail = false;
          this.dadosPaciente = qRes['objResultado'];
        }

        this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-profile-picture/";
      }
      else{

        if(qRes['res'] == 'invalid'){
          const avisoErro =  this.dialog.open(AlertaConfirmDialog, {
            // width: '250px',
            disableClose: true,
            data: {iconAlerta: 'warning', tituloAlerta: "Aviso",  textoAlerta: "Ocorreu um erro com suas credenciais, por favor efetue o login novamente", textoConfirm: "OK"}
          });
          avisoErro.afterClosed().subscribe((result) =>{
            if(this.tmaService.forceLogout().valueOf() == true){
              this.router.navigate(['/autenticar']);
            }
          });
        }
        if(qRes.length == 0){
          const avisoErro =  this.dialog.open(AlertaConfirmDialog, {
            disableClose: true,
            data: {tituloAlerta: "Aviso",  textoAlerta: "Verifique sua conexão com a internet. Tente novamente", textoCancel: "Voltar", textoConfirm: "Tentar Novamente"}
          });
          avisoErro.afterClosed().subscribe((result) =>{
            if(result == true){
              this.checkEmail();
            }
            else{
              this.voltar();
            }
          });
        }
      }
    })
  }

  backEmail() : void{
    this.etapaDados = false;
    this.jaCadastrado = false;
    this.etapaEmail = true;
  }

  criarRelacao() :void{
    //caso o paciente já seja cadastrado no tamas
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      idaluno: this.dadosPaciente.id
    };
    this.hideCL = false;
    this.tmaService.criarRelPA(customParams).subscribe((qRes) =>{
      this.hideCL = true;
      console.log(qRes);
      if(qRes['res'] == 'done'){
        this.router.navigate(['/dashboard/paciente/' + this.dadosPaciente.id]);
      }
      else{
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose:true,
          data: {textoAlerta: "Ocorreu um erro ao processar sua requisição. Tente novamente", iconAlerta: 'warning'}
        });
      }
    },
    (error) =>{
      this.hideCL = true;
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose:true,
        data: {textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning'}
      });
    })

  }

  cadastroPre() :void{
    //novo cadastro - paciente ainda não cadastrado

    if (this.nome.length <= 3) {
      const nomeInsuf = this.dialog.open(AlertaSimplesDialog, {
          data: {textoAlerta: "Por favor insira seu nome"}
      });
      nomeInsuf.afterClosed().subscribe(qq1 =>{
          //this.nomeInput.nativeElement.focus();
      });
      return ;
    }

    if (this.nascimento.length < 8) {
        const nascimentoInsuf = this.dialog.open(AlertaSimplesDialog, {
            data: {textoAlerta: "Para continuar informe a data de nascimento"}
        });
        nascimentoInsuf.afterClosed().subscribe(qq1 =>{
            //this.nascimentoInput.nativeElement.focus();
        });
        return ;
    }

    if (this.celular.length < 12) {
        const celularInsuf = this.dialog.open(AlertaSimplesDialog, {
            data: {textoAlerta: "Por favor digite o celular  DDD + 9 dígitos"}
        });
        celularInsuf.afterClosed().subscribe(qq1 =>{
            //this.celularInput.nativeElement.focus();
        });
        return ;
    }

    if(this.genero == ''){
      const sexoInv = this.dialog.open(AlertaSimplesDialog, {
        data: {textoAlerta: "Por favor informe o gênero do paciente"}
      });
    }




    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      emailP: this.email,
      nomeP: this.nome, 
      celularP: this.celular.replace(/\_/g, ''),
      dataNasc: this.nascimento,
      //altura: this.altura.replace('.',','),
      altura: this.altura.replace('.','').replace(',',''),
      peso: this.peso.toString().replace('.',',').replace('kg', '').replace('k', '').replace('kilos', '').replace('quilos', ''),
      sexo: this.genero
    };
    this.hideCL = false;
    this.tmaService.novoPreCadastro(customParams).subscribe((qRes) =>{
      this.hideCL = true;
      console.log(qRes);
      if(qRes['res'] == 'done'){
        const avisoDone =  this.dialog.open(AlertaConfirmDialog, {
          // width: '250px',
          disableClose: true,
          data: {iconAlerta: '', tituloAlerta: "Aviso",  textoAlerta: "Pré cadastro realizado, informe o paciente que ele receberá um e-mail para que possa concluir o cadastro e ter acesso ao Tamas", textoConfirm: "OK"}
        });
        avisoDone.afterClosed().subscribe((result) =>{
          this.router.navigate(['/dashboard/paciente/' + qRes['novoID']]);
        });
      }
      else{
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose:true,
          data: {textoAlerta: "Ocorreu um erro ao cadastrar este paciente. Tente novamente", iconAlerta: 'warning'}
        });
      }
    },
    (error) =>{
      this.hideCL = true;
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose:true,
        data: {textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning'}
      });
    })

  }

  exibirAll() :void{
    this.indexBusca = 0;
    this.router.navigate(['/dashboard/pacientes/all/all']);
  }
  novaPesquisa() :void{
    this.router.navigate(['/pesquisando/pessoas']);
  }
  
  goPerfil(nomeusuario: any) :void{
    this.tmaService.gUrlAnterior = this.router.url;
    this.router.navigate(['/dashboard/paciente/' + nomeusuario]);
  }

  voltar() :void{
    this.router.navigate(['/dashboard/home']);
  }

}
